import { render, staticRenderFns } from "./discuss_area.vue?vue&type=template&id=56bc41a4&scoped=true"
import script from "./discuss_area.vue?vue&type=script&lang=js"
export * from "./discuss_area.vue?vue&type=script&lang=js"
import style0 from "./discuss_area.vue?vue&type=style&index=0&id=56bc41a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc41a4",
  null
  
)

export default component.exports